import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/base.css';
import './styles/cursor.css';
import './styles/animations.css';
import './styles/components.css';
import './styles/theme.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
